module.exports = __webpack_public_path__ + "static/media/event-ret.21a89a7f.svg";